import {
  ADD_LAB_PATHOLOGIST,
  ADD_LAB_PATHOLOGIST_SUCCESS,
  ADD_LAB_PATHOLOGIST_FAIL,
  GET_LAB_PATHOLOGISTS,
  GET_LAB_PATHOLOGISTS_SUCCESS,
  GET_LAB_PATHOLOGISTS_FAIL,
  DELETE_LAB_PATHOLOGIST,
  DELETE_LAB_PATHOLOGIST_SUCCESS,
  DELETE_LAB_PATHOLOGIST_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  pathologists: [],
  loading: false,
  success: false,
  deleteSuccess: false,
  error: null,
};

const labPathologistReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_LAB_PATHOLOGIST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case ADD_LAB_PATHOLOGIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case ADD_LAB_PATHOLOGIST_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case GET_LAB_PATHOLOGISTS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_LAB_PATHOLOGISTS_SUCCESS:
      return {
        ...state,
        loading: false,
        pathologists: action.payload,
      };

    case GET_LAB_PATHOLOGISTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LAB_PATHOLOGIST:
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
      };

    case DELETE_LAB_PATHOLOGIST_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
        pathologists: state.pathologists.filter(
          item => item.id !== action.payload 
        ),
      };

    case DELETE_LAB_PATHOLOGIST_FAIL:
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labPathologistReducer;